import React from 'react'
import { Footer, Container, Content, Columns, Column, Icon } from 'bloomer'

const AppFooter = () => (
  <Footer id="footer">
    <Container>
      <Content>
        <Columns>
          <Column isFull>
            <p>
              Made with <a href="https://www.gatsbyjs.org/">GatsbyJS</a>, 
              Deployed with <a href="https://www.netlify.com/">Netlify</a>, 
              Hosted at <a href="https://gitlab.com/">GitLab</a>
            </p>
          </Column>
        </Columns>
      </Content>
    </Container>
  </Footer>
)

export default AppFooter



// WEBPACK FOOTER //
// ./src/components/Footer/index.js